module.exports = __webpack_public_path__ + "img/VAL DAY HEART.25ae0f4.svg";